import Header from "./components/Header";
import { Container } from "react-bootstrap";
import Footer from "./components/Footer";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import InactivityTimeout from "./components/InactivityTimeout";
import { Suspense, useEffect } from 'react';
import Loader from "./components/Loader";
import { useLocation } from 'react-router-dom';
import CookieConsent from "./components/CookieConsent";
import WelcomeOfferPopup from "./components/WelcomeOfferPopup";

// Scrolls to top on every route change
function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

const App = () => {
    const location = useLocation();

    // Add body classes based on current route
    useEffect(() => {
        document.body.className = '';

        if (location.pathname === '/') {
            document.body.classList.add('landing-page');
        } else if (location.pathname.includes('/search') || location.pathname.includes('/page/')) {
            document.body.classList.add('home-page');
        } else if (location.pathname.includes('/product/')) {
            document.body.classList.add('product-page');
        } else if (location.pathname === '/cart') {
            document.body.classList.add('cart-page');
        } else if (
            location.pathname.includes('/shipping') ||
            location.pathname.includes('/payment') ||
            location.pathname.includes('/placeorder')
        ) {
            document.body.classList.add('checkout-page');
        } else if (
            location.pathname.includes('/profile') ||
            location.pathname.includes('/wishlist') ||
            location.pathname === '/orders' ||
            location.pathname.includes('/orderhistory')
        ) {
            document.body.classList.add('profile-page');
        } else if (location.pathname.includes('/admin')) {
            document.body.classList.add('admin-page');
        }
    }, [location]);

    return (
        <>
            <Header />
            <ScrollToTop />
            <InactivityTimeout />
            <main className='main-content'>
                <Container>
                    <Suspense fallback={<Loader />}>
                        <Outlet />
                    </Suspense>
                </Container>
            </main>
            <Footer />
            <CookieConsent />
            <WelcomeOfferPopup />
            <ToastContainer />
        </>
    );
};

export default App;